import { useContext } from 'react';
import { FavoritesContext } from '../providers/FavoritesProvider';

export const useFavorites = () => {
    const context = useContext(FavoritesContext);

    if (context === undefined || context === null) {
        throw new Error('useFavorites must be used within a FavoritesContext');
    }

    return context;
};
